export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/zh-tw.lyaml"));
at({ "zh-tw": { "public": { "sampleString": "\u7BC4\u4F8B\u5B57\u4E32" } } });
};